// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1018":"8c34543e","3219":"250ab759","8371":"9cb4bc4e"}[chunkId] + ".css";
};